/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-face-to-face': {
    width: 9,
    height: 10,
    viewBox: '0 0 9 10',
    data: '<path pid="0" d="M8.8 8.9a.322.322 0 00-.333-.298h-.566V.999c0-.045 0-.091-.004-.136a.532.532 0 00-.461-.455A1.005 1.005 0 007.302.4h-5.78a.78.78 0 00-.172.016.524.524 0 00-.418.49c-.003.129 0 .258 0 .388l.001 7.308H.665c-.106 0-.212-.006-.318-.004l-.014-.002c-.174 0-.34.14-.333.302a.325.325 0 00.333.302h8.134c.174 0 .342-.138.333-.3zM6.48 5.04a.59.59 0 01-.59.147.51.51 0 01-.372-.452v-.03a.514.514 0 01.435-.467c.23-.037.46.048.581.23a.46.46 0 01-.053.572z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
